export default {
  state: {
    extensionStatus: 'disconnected',
    session: null
  },
  getters: {
    extensionStatus(state) {
      return state.extensionStatus
    },
    session(state) {
      return state.session
    }
  },
  mutations: {
    setExtensionStatus(state, payload) {
      state.extensionStatus = payload
    },
    setSession(state, payload) {
      state.session = payload
    }
  },
  actions: {
    async extensionLogin({ commit }) {
      commit('setExtensionStatus', 'connected')
    },
    async extensionLogout({ commit }) {
      commit('setExtensionStatus', 'disconnected')
    },
    async setSession({ commit }, payload) {
      commit('setSession', payload)
    }
  }
}
